import { connect } from 'react-redux';
import { requestInvoicePdfUrlThunk } from '../../../actions/thunks/requestInvoicePdfUrl';
import type {
  AppThunkAction,
  AppThunkDispatch
} from '../../../actions/thunkType';
import Table from '../../../components/project/billing/Table';

const requestInvoicePdfUrl =
  (urlCode: UrlCode): AppThunkAction<void> =>
  dispatch => {
    dispatch(requestInvoicePdfUrlThunk(urlCode))
      .then(downloadUrl => {
        if (downloadUrl) {
          location.href = downloadUrl;
        }
      })
      .catch(() => {});
  };

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
  requestInvoicePdfUrl: (urlCode: UrlCode) =>
    dispatch(requestInvoicePdfUrl(urlCode))
});

export type TablePropsMappedFromState = ReturnType<typeof mapStateToProps>;
export type TablePropsMappedFromDispatch = ReturnType<
  typeof mapDispatchToProps
>;

export default connect(mapStateToProps, mapDispatchToProps)(Table);
